<template>
  <div id='live-video'></div> 
</template>

<script>
export default {
  props: {
    source:{
      type: String
    },
  },
  async mounted() {
    
      await window.jwplayer('live-video').setup({ 
        sources: [{file:this.source}],
        width: "100%"
      })
    console.log(this.liveStreamDetail)
  },
  methods: {}
};
</script>
